<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="#37474F"
        dark
    >    
    <v-toolbar-title>[ 템플릿 관리 ]   http://madbundle.studiomadpj.co.kr/  </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="blue-grey lighten-2"
            small
            fab
            v-bind="attrs"
            v-on="on"
        >
            <v-icon 
            color= "blue-grey darken-1"
            >mdi-help</v-icon>
        </v-btn>
    </template>
    <span>테이블은 올리자마자 바로 배포되며 , 개발서버, 라이브서버 각 구분되어있습니다.</span>
    </v-tooltip>
    </v-toolbar>

    
    <v-list>
        <!-- 템플릿 버전 -->
        <v-list-item>
        <span class="label-col" style="width:160px"><v-card-title class="font-weight-bold">템플릿 업로드</v-card-title></span>
        <span class="input-col" style="width:60%">                      
        <v-file-input
            label="테이블을 압축해서 올려주세요."
            v-model="inputTemplate"
            @change="(file) => onFileChange(file)"
        ></v-file-input> 
        </span>
        <v-divider vertical="vertical"/>
        <v-spacer></v-spacer>
        <span class="label-col" style="width:200px"><v-card-title class="font-weight-bold"> OS : {{OS_TagConvert(isIOS)}}</v-card-title></span>
            <v-switch
                v-model="isIOS"            
                inset
                hide-details
            ></v-switch>
        </v-list-item>   
        <v-divider/>     
        <!-- 템플릿 버전  -->
        <v-list-item>
        <span class="label-col" style="width:160px"><v-card-title class="font-weight-bold">템플릿 버전</v-card-title></span>
        <v-text-field            
            label="(ex: 1.0.1 )"
            v-model="templateVer"
            type="text"
            value=""            
        ></v-text-field> 
        </v-list-item>       
        <!-- 템플릿 코멘트   -->
        <v-list-item>
        <span class="label-col" style="width:160px"><v-card-title class="font-weight-bold">업로드 코멘트</v-card-title></span>
        <v-text-field            
            label="(ex: 대사 일부 수정 )"
            v-model="comment"
            type="text"
            value=""            
        ></v-text-field> 
        </v-list-item>       
        <v-list-item>       
            <v-spacer></v-spacer>            
            <v-btn color="lime accent-3" @click="OnUpload_Template">템플릿 업로드</v-btn>
            <v-spacer></v-spacer>
        </v-list-item>    

    </v-list>
    </v-card>
    
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="grey darken-1"
        dark
    >    
    <v-toolbar-title>테이블 업로드 이력</v-toolbar-title>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="history_all"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.VERSION}}</td>
            <td>{{row.item.ADMIN}}</td>
            <td>{{row.item.REG_DT}}</td>
            <td>{{row.item.COMMENT}}</td>
            <td>{{OS_TagConvert(row.item.OS)}}</td>
            <td>
                <v-btn 
                class="mx-2" 
                fab 
                dark 
                small 
                color="indigo lighten-3"
                :href="downloadUrl + row.item.FILE_PATH"
                download
                >
                    <v-icon dark>mdi-tray-arrow-down</v-icon>
                </v-btn>
            </td>         
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>
    </div>   
    
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
 const { s3_upload } = require("../../util/fileutil");

export default {
    name: 'UserList',

    data: () => ({
        isIOS:false,
        selectedTag:"안드로이드",
        downloadUrl:"http://madbundle.studiomadpj.co.kr/",
        loadingData:false,        
        inputTemplate:[],
        templateVer:"1.0.0",
        date_begin: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_end:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        comment:"",
        itemInfoList:[
            {
                name:'보석',
                value:'item_type_1',
            },
            {
                name:'골드',
                value:'item_type_2',
            }   
        ],
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록 
        // 데이터테이블에 저장위치의 경로와 다운로드 버튼을 만들어 클릭하면 나올 수 있게 한다.
        headers: [            
            { text: '버전', value: 'title' },
            { text: '관리자', value: 'admin' },
            { text: '등록일자', value: 'regist_date' },
            { text: '코멘트', value: 'comment' },
            { text: 'OS', value: 'regist_date' },
            { text: '다운로드', value: 'comment' },
        ],
        history_all:[
            {  
                title: '테스트 메일 입니다.',
                admin: 'justin',
                regist_date:'2021-10-10 12:00:00',
                get_date:'2021-10-10 12:00:00',
                target:'ALL',
                active_yn:'Y',
            },
        ]
    }),

    created()
    {
        this.date_end = moment().add(3,'M').format('yyyy-MM-DD');
        this.Refresh_TempatleLogs();
    },

    methods:{
        ...mapActions([
            'GET_TEMPLATE_LOG',
            'INSERT_TEMPLATE_LOG'
        ]),
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        OnUpload_Template()
        {
        //    function s3_upload_tempalte(_inputFile, _fileName , _listener)
            console.log("OnUpload_Template " + JSON.stringify(this.inputTemplate));
            //function s3_upload_tempalte(this.inputTemplate, _fileName , _listener)
            let packageName = this.$store.state.selected_game_package;
            let templateVer = this.templateVer;
            let comment = this.comment;
            let serverState= "dev";
            if(this.isLive)
                serverState = "live";
            else
                serverState = "dev";
                
            let fileName = this.CreateRandomFileName();
            let file_path = `CommonTemplate/${serverState}/${packageName.replaceAll('.', '_')}/${fileName}`;
            console.log(file_path);
            ///file_path = "CommonTemplate/test";
            let isIOS = (this.isIOS == false)?0:1;
           

            // FileUpload_Async(this.inputTemplate, file_path, (_result)=>{
            //     if(_result == null)
            //     {
            //         console.log("에러가 없습니다.");
            //           this.INSERT_TEMPLATE_LOG({packageName, templateVer , comment, file_path, isIOS}).then((body_data)=>{
            //             this.Refresh_TempatleLogs();
            //         });
            //     }
            //     else{
            //         alert("업로드 실패 다시 시도해주세요.");
            //         console.log("에러가 있습니다.  : " + file_path + ": " + _result);
            //     }
            // }); 
          
        },
        Refresh_TempatleLogs()
        {//등록된 아이템 정보 + 1
            let packageName = this.$store.state.selected_game_package;
            
            this.GET_TEMPLATE_LOG({packageName}).then((body_data)=>{
                console.log(body_data);
                this.history_all = body_data.log_list;
                console.log(this.history_all);
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        CreateRandomFileName()
        {
            let baseStrContainer = '123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            let charactersLength = baseStrContainer.length;
            let randomString = '';
            for (var i = 0; i < 16; i++) {
                //return Math.random() * (max - min) + min;
                randomString += baseStrContainer.charAt(this.getRandomArbitrary(0, charactersLength - 1));
            }
            return randomString;
        },

        getRandomArbitrary(min, max) {
            return Math.random() * (max - min) + min;
        },

        OnRemoveItem(_index)
        {
            this.selected_itemList[_index] = undefined;
            this.Refresh_ItemInfo();
        },
        onFileChange(file) {
            console.log("onFileChang2e  1  : " + JSON.stringify(file));
            var files = this.inputTemplate;// || e.dataTransfer.file;
            console.log("onFileChange  2  + " + JSON.stringify(this.inputTemplate) );
        
            //this.inputTemplate = files[0];
            console.log("onFileChange  3");
            console.log(this.inputTemplate);
            console.log("onFileChange  4");
            //this.createImage(files[0]);
        },
        OS_TagConvert(_os)
        {
            if(_os  == 0)
                return  "안드로이드";
            else
                return "아이폰";
        }
    },
    computed: {
        isLive(){
            return config.isLive;
        },
        computedDateFormattedMomentjs_begin () {
            return this.date_begin ? moment(this.date_begin).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.date_end ? moment(this.date_end).format('YYYY-MM-DD') : ''
        },  
    },
    components:{
    },
    watch :{
            '$store.state.selected_game_package': function() {
            console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            this.Refresh_TempatleLogs();
        }
    }
};
</script>

<style scoped>
@media (max-width: 600px) {
  .v-list-item {
    flex-wrap: wrap;
  }
  .v-list-item .label-col {
    width: 100% !important;
  }
  .v-list-item .input-col {
    width: 100% !important;
  }
}
</style>
